module.exports = __webpack_public_path__ + "images/corner-taco.00d28d194474da79d285.svg";